// 日期格式化
export function parseTime(date, fmt) {
  let ret;
  let _len;
  const opt = {
    "y+": date.getFullYear().toString(),        // 年
    "M+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "m+": date.getMinutes().toString(),         // 分
    "s+": date.getSeconds().toString(),         // 秒
    "S+": date.getMilliseconds().toString()     // 毫秒
  };
  for (let k in opt) {
    ret = new RegExp("({" + k + "})").exec(fmt);
    if (ret) {
      _len = ret[1].length - 2;
      fmt = fmt.replace(ret[1], (_len == 1) ? (opt[k]) : (opt[k].padStart(_len, "0")));
    };
  };
  return fmt;
}


// WEBPACK FOOTER //
// ./src/utils/index.js